import React from 'react';
import { travelPassProductShape } from 'constants/propTypes';
import SubscriptionDetails from './SubscriptionDetails';
import moment from 'moment';

const Subscription = ({ travelPassProduct }) => {
  const { itemRef, passenger, startDate, endDate, name, currency, price } = travelPassProduct;
  const formattedStartDate = moment(startDate, 'YYYY-MM-DD').format('DD-MM-YYYY');
  const formattedEndDate = moment(endDate, 'YYYY-MM-DD').format('DD-MM-YYYY');

  return (
    <>
      <div data-cy={`subscription-${itemRef}`} data-testid={`subscription-${itemRef}`}>
        <SubscriptionDetails
          firstName={passenger?.firstName}
          lastName={passenger?.lastName}
          startDate={formattedStartDate}
          endDate={formattedEndDate}
          name={name}
          currency={currency}
          price={price}
        />
      </div>
    </>
  );
};

Subscription.propTypes = {
  travelPassProduct: travelPassProductShape.isRequired
};

export default Subscription;
